import React, {Component} from 'react';
import ProgressBar from 'progressbar.js';


class Progressbars extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.name || null,
            progress: this.props.progress,
            barType: this.props.barType
        }
        this.line = this.line.bind(this);
        this.circle = this.circle.bind(this);

    }


    line(e) {
        let barName = this.state.name;
        let progress = this.state.progress;
        if (barName != null) {
            let line = new ProgressBar.Line(`.${barName}`, {
                strokeWidth: 2,
                easing: 'easeInOut',
                duration: 1400,
                color: '#176CBB',
                trailColor: '#eee',
                trailWidth: 1,
                svgStyle: {width: '100%', height: '100%'},
                text: {
                    style: {
                        color: '#999',
                        position: 'absolute',
                        right: '0',
                        top: '0',
                        padding: 0,
                        margin: 0,
                        transform: null
                    },
                    autoStyleContainer: false
                },
                from: {color: '#176CBB'},
                to: {color: '#176CBB'},
                step: (state, bar) => {
                    bar.setText(Math.round(bar.value() * 100) + ' %');
                }
            });
            line.animate(progress);  // Number from 0.0 to 1.0
        }

    }

    circle(e) {
        let barName = this.state.name;
        let progress = this.state.progress;
        if (barName != null) {
            let circle = new ProgressBar.Circle(`.${barName}`, {

                color: '#176CBB',
                trailWidth: 8,
                easing: 'easeInOut',
                duration: 1400,
                text: {
                    autoStyleContainer: false,
                    style: {
                        color: '#999',
                        position: 'absolute',
                        left: '42%',
                        top: '32%',
                        padding: 0,
                        margin: 0,
                        transform: null
                    },
                },
                strokeWidth: 8,
                from: {color: '#aaa', width: 1},
                to: {color: '#176CBB', width: 6},
                step: function (state, circle) {
                    circle.path.setAttribute('stroke', state.color);
                    circle.path.setAttribute('stroke-width', state.width);
                    var value = Math.round(circle.value() * 100);
                    if (value === 0) {
                        circle.setText('');
                    } else {
                        circle.setText(value);
                    }

                }
            });
            circle.stokeWidth = 8;
            circle.text.style.fontSize = '1.5rem';
            circle.animate(progress);
        }

    }

    render() {
        let {name, barType} = this.state;
        if (barType == 'line') {
            return <div className={name} ref={this.line}></div>
        }
        if (barType == 'circle') {
            return <div className={name} ref={this.circle}></div>
        }
    }
}

export default Progressbars;





// WEBPACK FOOTER //
// src/components/Progressbars.js